(function () {
  'use strict';

  const dialog = document.getElementById('tk-korea-store-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const preferenceKey = 'tk_korea_store_popup_dismissed_until_v1';
  const preferenceDuration = 7 * 24 * 60 * 60 * 1000;

  function hasPreference() {
    try {
      return Number(localStorage.getItem(preferenceKey)) > Date.now();
    } catch {
      return false;
    }
  }

  function rememberPreference() {
    try {
      localStorage.setItem(preferenceKey, String(Date.now() + preferenceDuration));
    } catch {
      return;
    }
  }

  dialog.addEventListener('submit', rememberPreference);
  dialog.addEventListener('cancel', rememberPreference);
  dialog.querySelector('[data-tk-korea-visit]').addEventListener('click', rememberPreference);

  async function offerKoreanStore() {
    if (hasPreference()) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
        signal: AbortSignal.timeout(4000)
      });
      if (!response.ok) return;

      const context = await response.json();
      if (context?.detected_values?.country?.handle !== 'KR') return;
      if (hasPreference() || document.querySelector('dialog[open]')) return;

      dialog.showModal();
    } catch {
      return;
    }
  }

  offerKoreanStore();
}());
